let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("aGJ4a")]).then(() => parcelRequire('gp1NP'));